import { combineReducers } from 'redux';
import {
    BookingsState,
    initialState as bookingsInitialState,
    reducer as bookingsReducer,
} from './bookingsReducer';
import {
    AuthenticationState,
    initialState as authenticationInitialState,
    reducer as authenticationReducer,
} from './authenticationReducer';
import {
    LocationsState,
    initialState as locationsInitialState,
    reducer as locationsReducer,
} from './locationsReducer';
import {
    DepotsState,
    initialState as depotsInitialState,
    reducer as depotsReducer,
} from './depotsReducer';
import {
    IssueReportsState,
    initialState as issueReportsInitialState,
    reducer as issueReportsReducer,
} from './issueReportsReducer';
import {
    SnackbarState,
    initialState as snackbarInitialState,
    reducer as snackbarReducer,
} from './snackbarReducer';

export interface ReduxState {
    authentication: AuthenticationState;
    bookings: BookingsState;
    locations: LocationsState;
    depots: DepotsState;
    issueReports: IssueReportsState;
    snackbar: SnackbarState;
}

export const initialState: ReduxState = {
    authentication: authenticationInitialState,
    bookings: bookingsInitialState,
    locations: locationsInitialState,
    depots: depotsInitialState,
    issueReports: issueReportsInitialState,
    snackbar: snackbarInitialState,
};

export const rootReducer = combineReducers({
    authentication: authenticationReducer,
    bookings: bookingsReducer,
    locations: locationsReducer,
    depots: depotsReducer,
    issueReports: issueReportsReducer,
    snackbar: snackbarReducer,
});
